export const REDUCER_NAME = 'sellInquiryForm'
export const SELL_INQUIRY_FORM_DATA = 'data'
export const SELL_INQUIRY_FORM_FILE_DATA = 'fileData'
export const IS_SAVING_FILE_DATA = 'isSavingFileData'

export const SET_IS_LOADING_SELL_INQUIRY_FORM_DATA = 'SET_IS_LOADING_SELL_INQUIRY_FORM_DATA'
export const SET_IS_SAVING_SELL_INQUIRY_FORM_DATA = 'SET_IS_SAVING_SELL_INQUIRY_FORM_DATA'
export const SET_IS_SAVING_SELL_INQUIRY_FORM_FILE_DATA = 'SET_IS_SAVING_SELL_INQUIRY_FORM_FILE_DATA'
export const SET_SELL_INQUIRY_FORM_DATA = 'SET_SELL_INQUIRY_FORM_DATA'
export const SET_SELL_INQUIRY_FORM_FILE_DATA = 'SET_SELL_INQUIRY_FORM_FILE_DATA'
export const SET_SELL_INQUIRY_FORM_RESPONSE_DATA = 'SET_SELL_INQUIRY_FORM_RESPONSE_DATA'
export const SET_SELL_INQUIRY_FORM_FILE_RESPONSE_DATA = 'SET_SELL_INQUIRY_FORM_FILE_RESPONSE_DATA'
